import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, TextField, Typography } from "@mui/material";
import "../../Dashboard/View/PromocodeDashboard.css";
import { inputStyles } from "../../CreateNewPromodeod/View/CreatePromoCode";
import { useUpdatePromoCode } from "../../../store/Apis/StripeApi";
import { setSnackBarAlert } from "../../../store/one-query/chatsSlice";
import { useAppDispatch } from "../../../store/hooks";

interface EditPromoCodeProps {
  open: boolean;
  setIsPromoUpdated: (open: boolean) => void;
  setOpen: (open: boolean) => void;
  codeName: string;
  codeDescription: string;
  codeId: string;
}
export const EditPromoCode = ({
  open,
  setOpen,
  codeName,
  codeDescription,
  codeId,
  setIsPromoUpdated,
}: EditPromoCodeProps) => {
  const dispatch = useAppDispatch();
  const handleClose = () => setOpen(false);
  const [codeNameInputValue, setCodeNameInputValue] = useState("");
  const [descInputValue, setDescInputValue] = useState("");
  const { mutate: UpdatePromoCodeRequest, isSuccess: IsPromoCodeUpdated } =
    useUpdatePromoCode();

  const handleCodeNameInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setCodeNameInputValue(event.target.value);
  };

  const handleDescriptionInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setDescInputValue(event.target.value);
  };

  useEffect(() => {
    if (codeName) {
      setCodeNameInputValue("");
      setCodeNameInputValue(codeName);
    }
    if (codeDescription) {
      setDescInputValue("");
      setDescInputValue(codeDescription);
    }
  }, [codeName, codeDescription]);

  const handleSaveUpdating = () => {
    let UpdatedDate = {
      promoCodeId: codeId,
      codeName: codeNameInputValue,
      description: descInputValue,
    };
    if (UpdatedDate) {
      UpdatePromoCodeRequest(UpdatedDate);
    }
  };

  useEffect(() => {
    if (IsPromoCodeUpdated) {
      setIsPromoUpdated(true);
      handleClose();
      dispatch(
        setSnackBarAlert({
          show: true,
          message: "Promo-code updated successfully",
          alertType: "success",
        })
      );
    }
  }, [IsPromoCodeUpdated]);
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="promo-dialog"
        sx={{
          "& .MuiDialog-paper": {
            width: 500,
            borderRadius: "12px",
          },
        }}
      >
        <DialogTitle id="promo-alert-title">Edit promo code</DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{
              border: "none !important",
              padding: "16px 0 0 0 !important",
              borderRadius: "12px",
            }}
          >
            {" "}
            <Box
              className="codeName box"
              sx={{ marginBottom: "1rem !important" }}
            >
              <Box className="box-titles">
                <Typography className="box-title">Code Name</Typography>
                <Typography className="box-description">
                  This will appear on customers' receipts and invoices.
                </Typography>
              </Box>
              <Box className="inputs-box">
                <TextField
                  value={codeNameInputValue}
                  onChange={handleCodeNameInputChange}
                  maxRows={1}
                  sx={{ ...inputStyles, width: "100%" }}
                />
              </Box>
            </Box>
            <Box className="description box" sx={{ margin: 0 }}>
              <Typography className="box-title">Description</Typography>
              <Box className="inputs-box">
                <TextField
                  multiline
                  maxRows={2}
                  minRows={2}
                  value={descInputValue}
                  onChange={handleDescriptionInputChange}
                  sx={{
                    ...inputStyles,
                    width: "100%",
                    "& .MuiInputBase-input": {
                      padding: "0",
                      color: "#fff",
                      caretColor: "#12B6EA",
                    },
                  }}
                />
              </Box>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Box className="RegisterOrSignIn">
            <Box className="buttons">
              <button
                className="signInBtn cancel-promoCode-changes"
                onClick={handleClose}
              >
                <span>Cancel</span>
              </button>

              <button
                className="registerBtn save-promoCode-changes"
                onClick={handleSaveUpdating}
              >
                <span>Save</span>
              </button>
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};
